module.exports = __webpack_public_path__ + "static/media/headphone-benifits.de7f30f7.webp";